module.exports = __webpack_public_path__ + "static/4-cc4bf11d83b6bb1336a26a03c64d3db9.svg";